import React from 'react';
import { Phone, Mail } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { contactInfo } from '../mock';

export const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-[#1F3C88] text-white py-12">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-2xl font-bold mb-4">GoBru</h3>
            <p className="text-gray-200">
              Reliable taxi service in Belgium
            </p>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">Contact</h4>
            <div className="space-y-2">
              <a
                href={`tel:${contactInfo.phone}`}
                className="flex items-center space-x-2 text-gray-200 hover:text-[#FBC02D] transition-colors"
              >
                <Phone className="h-4 w-4" />
                <span>{contactInfo.phone}</span>
              </a>
              <a
                href={`mailto:${contactInfo.email}`}
                className="flex items-center space-x-2 text-gray-200 hover:text-[#FBC02D] transition-colors"
              >
                <Mail className="h-4 w-4" />
                <span>{contactInfo.email}</span>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4">WhatsApp</h4>
            <a
              href={`https://wa.me/${contactInfo.whatsapp.replace(/\s+/g, '')}`}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center px-4 py-2 bg-[#FBC02D] text-[#1F3C88] font-semibold rounded-lg hover:bg-[#f9b200] transition-colors"
            >
              {contactInfo.whatsapp}
            </a>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-gray-700 text-center text-gray-300">
          <p>© GoBru – {t.footer.allRights}</p>
        </div>
      </div>
    </footer>
  );
};